import { render, staticRenderFns } from "./cartao.vue?vue&type=template&id=b4b8bf08"
import script from "./cartao.vue?vue&type=script&lang=js"
export * from "./cartao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports